module.exports = __webpack_public_path__ + "static/media/menuShare.64c393b7.svg";